import { Component, OnInit, Inject, Injectable, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/http/auth.service';
import { DOCUMENT } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { AppConfig } from 'src/app/config/config';
import { UserService } from 'src/app/services/http/user.service';
import { ActivatedRoute } from '@angular/router';
import { ApplicationService } from 'src/app/services/http/application.service';
import { SupportFormComponent } from '../support-form/support-form.component';
import { TermsAndConditionsComponent } from '../terms-and-conditions/terms-and-conditions.component';
import { CommonService } from 'src/app/services/http/common.service';
declare var $: any; 
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, PopupRequest, RedirectRequest, EventMessage, EventType } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, AfterViewInit, OnDestroy {
  //heed help
  @ViewChild(SupportFormComponent) popupComponentRef!: SupportFormComponent;
  show:boolean = false;

  public email!: string;
  public password!: string;
  public resetPasswordForm: boolean = false;
  public showPw: boolean = false;
  public insertCode: boolean = false;
  public showSupport: boolean = false;
  public code!: string;
  codeNumber: string[] = ['', '', '', '', '', ''];
  
  private readonly _destroying$ = new Subject<void>();
  
  public showCodeInputField: boolean = false;

  public newPasswordForm: boolean = false;
  public newPassword: string = '';
  public confirmNewPassword: string = '';
  private pathApi = this.config.setting['pathApi'] + "auth/";

  mail: any = {
    email: '',
    message: '',  
  };

  public emailValid: boolean = true;
  showNewPw: boolean = false;
  showConfirmNewPw: boolean = false;
  appColor: any = null;
  appName: any = 'Identity';
  useMicrosoftLogin: boolean = false;
  @ViewChild('backgroundVideo') backgroundVideo: any;
  secondsPassed: number = 0;
  private intervalId: any;
  @ViewChild('modalComp') modalComp!: TermsAndConditionsComponent;
  public passwordLength: number = 12;
  loginDisplay = false;
  public microsoftLoginPath: string = this.pathApi + "microsoft-login";
  

  constructor(private authService: AuthService, private config: AppConfig,
    private router: Router, private userService: UserService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private applicationService: ApplicationService,
    private commonService: CommonService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    @Inject(DOCUMENT) private document: Document
  ) {
  }

  ngOnInit(): void {
    var id = '';
    var redirect_uri = '';
    this.route.queryParams.subscribe(params => {
        id = params['client_id'];
        
    });
    
    redirect_uri = this.document.referrer;

    if(id != '' && id != undefined) {
      this.applicationService.getByClientId(id).subscribe(response => {
        if (response.status === 200) {
          this.appColor = response.data.color;
          this.appName = response.data.applicationName.toLowerCase();
          this.useMicrosoftLogin = response.data.microsoftLoginEnabled;
        } else{
          this.toastr.error(response.message);        
        }
      }, error => {
        this.toastr.error('An error occurred.');        
      });
    }

    if(id != '' && redirect_uri != '') {
      this.intervalId = setInterval(() => {
        this.secondsPassed++;

        if (this.secondsPassed >= 600) { // 10 minutes
          clearInterval(this.intervalId);
          const url = new URL(redirect_uri);
          window.location.href = url.origin;
        }
      }, 1000);
    }

    this.authService.getPasswordLength().subscribe(response => {
        if (response.status == 200) {
          this.passwordLength = response.data;
        }
        else
          this.toastr.error(response.message);
    });
    
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.checkAndSetActiveAccount();
      })
  }

  

  checkAndSetActiveAccount(){
    let activeAccount = this.msalService.instance.getActiveAccount();

    if (!activeAccount && this.msalService.instance.getAllAccounts().length > 0) {
      let accounts = this.msalService.instance.getAllAccounts();
      this.msalService.instance.setActiveAccount(accounts[0]);
    }
    
  }

  async loginWithMicrosoft(email: string, event?: Event): Promise<void> {
    event?.preventDefault();

    try {      
      const emailField = document.getElementById('emailField') as HTMLInputElement;
      emailField.value = email;

      const queryParamsString = this.router.serializeUrl(
        this.router.parseUrl(this.router.url)
      ).split('?')[1];

      const queryParamsField = document.getElementById('queryParamsField') as HTMLInputElement;
      queryParamsField.value = queryParamsString;
      
      const form = document.getElementById('msLoginForm') as HTMLFormElement;
      form.submit();
      
    } catch (error) {
      console.error('Microsoft login failed:', error);
    }
  }

  loginPopup() {
    if (this.msalGuardConfig.authRequest){
      const switchAccountRequest: PopupRequest = {
        ...this.msalGuardConfig.authRequest,
        prompt: 'select_account', 
        scopes: ['user.read']     
      };

      setTimeout(() => {
        this.msalService.loginPopup(switchAccountRequest)
        .subscribe((response: AuthenticationResult) => {
          const email = response.account?.username ?? (response.idTokenClaims as any)?.['preferred_username'] as string;
          const queryParamsString = this.router.serializeUrl(this.router.parseUrl(this.router.url)).split('?')[1];
            
          if(queryParamsString != undefined) {          
            this.loginWithMicrosoft(email);        
          } else {
            this.authService.loginEntraAdmin(response.accessToken).subscribe((res) => {
              if(res.status == 200 || !res.status)
                this.authService.afterLogin(res);
              else if(res.status == 400 && res.data == true) {
                this.insertCode = true;
                this.toastr.error(res.message);
              }
              else if(res.message) {
                this.password = '';
                this.toastr.error(res.message)
              }
              else {
                this.toastr.error('An error ocurred.')
              }
            }, (error: any) => {
              if (error != null && error.error != null && error.error.message != null)
                this.toastr.error(error.error.message)
              else
                this.toastr.error('An error ocurred.');
            });
          }

          this.msalService.instance.setActiveAccount(response.account);
        });
      }, 1000);
      
    } 
  }

  ngAfterViewInit() {
    if(this.backgroundVideo != null) {
      const video: HTMLVideoElement = this.backgroundVideo.nativeElement;
      video.play().catch((error) => {
        console.error('Error playing the background video:', error);
      });
    }
  }

  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const clipboardData = event.clipboardData;
    const pastedData = clipboardData?.getData('text/plain') || '';
    const digits: string[] = pastedData.replace(/[^0-9]/g, '').slice(0, 6).split('');

    digits.forEach((digit: string, index: number) => {
      if (index < this.codeNumber.length) {
        this.codeNumber[index] = digit;
      }
    });
  }

  // Handle individual input and move focus to the next input
  onInput(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    const nextInput = input.nextElementSibling as HTMLInputElement;

    if (input.value && nextInput) {
      nextInput.focus();
    }
  }
  login() {
    //try temp password
    this.authService.isPasswordTemp({ username: this.email, password: this.password }).subscribe((res: any) => {
      if (res.status == 200) {
        this.newPasswordForm = true;
        return;
      }
      else {
        this.newPasswordForm = false;      
        this.loginWithPermanent();
      }
    }, (error: any) => { });
  }

  openSupport(){
    console.log(this.showSupport);
    this.showSupport = !this.showSupport;
  }
  
  loginWithPermanent() {
    //login
    const queryParamsString = this.router.serializeUrl(this.router.parseUrl(this.router.url)).split('?')[1];
    if (queryParamsString != undefined && queryParamsString.includes("client_id")) //login for other app
    {
      this.authService.login({ username: this.email, password: this.password }, queryParamsString).subscribe((res) => {
        if (res.status == 200) {
          this.document.location.href = this.pathApi + 'connect/authorize?' + queryParamsString;          
        }
        else if(res.status == 400 && res.data == true) {
          this.insertCode = true;
          this.toastr.success(res.message);
        }  
        else
          this.toastr.error(res.message)
      })
    }
    else //login for out app
    {
      this.loginAsAdmin();
    }
  }

  validatePass() {
    if (this.newPassword?.length < this.passwordLength) {
      this.toastr.error("Password must be at least " + this.passwordLength + " characters");
      return false;
    }
    if (this.newPassword?.search(/[$&+,:;=?@#|'<>.^*()%!-]/) < 0) {
      this.toastr.error("Password must contain at least one special character ($&+,:;=?@#|'<>.^*()%!-).");
      return false;
    }
    if (this.newPassword.search(/[A-Z]/) < 0) {
      this.toastr.error("Password must contain at least one Uppercase letter.");
      return false;
    }
    if (this.newPassword.search(/[a-z]/) < 0) {
      this.toastr.error("Password must contain at least one Lowercase letter.");
      return false;
    }
    if (this.newPassword?.search(/[0-9]/) < 0) {
      this.toastr.error("Password must contain at least 1 number.");
      return false;
    }
    if (this.newPassword != this.confirmNewPassword) {
      this.toastr.error("Passwords must match");
      return false;
    }
    return true;
  }

  changePassword() {
    if (!this.validatePass())
      return;

    let obj = {
      oldPassword: this.password,
      newPassword: this.newPassword,
      email: this.email
    }
    this.authService.changePassword(obj).subscribe(response => {
      if (response.status == 200) {
        this.toastr.success(response.message);
        this.newPasswordForm = false;
      }
      else
        this.toastr.error(response.message);
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }

  forgotPassword() {
    const queryParamsString = this.router.serializeUrl(this.router.parseUrl(this.router.url)).split('?')[1];
    const client_id = queryParamsString?.split('&')[0].split('=')[1];
    const redirect_uri = queryParamsString?.split('&')[1].split('=')[1];
    console.log(queryParamsString?.split('&'));
    console.log(redirect_uri);
    this.authService.forgotPasswordRequest({email: this.email, clientId: client_id, applicationUrl: this.decodeAndExtractBaseUrl(redirect_uri)}).subscribe(response => {
      if (response.status == 200) {
        this.toastr.success(response.message);
        this.resetPasswordForm = false;
      }
      else
        this.toastr.error(response.message);
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }

  validateCode() {
    this.code = this.codeNumber.join('');
    this.authService.validateCode({code: this.code, email: this.email}).subscribe(response => {
      if(response.status == 200) {
        this.toastr.success(response.message);
        const queryParamsString = this.router.serializeUrl(this.router.parseUrl(this.router.url)).split('?')[1];
        if(queryParamsString != null) {
          this.document.location.href = this.pathApi + 'connect/authorize?' + queryParamsString;
        } else {
          this.loginAsAdmin();
        }
      } else {
        this.toastr.error(response.message);
      }
    }, error => {
      this.toastr.error('An error occurred.');
    }
    );
  }

  showPassword() {
    this.showPw = !this.showPw;
  }
  showNewPassword() {
    this.showNewPw = !this.showNewPw;
  }
  showConfirmNewPassword() {
    this.showConfirmNewPw = !this.showConfirmNewPw;
  }

  loginAsAdmin() 
  {
    let formParams = new Map<string, string>();
      formParams.set("username", this.email.trim());
      formParams.set("password", this.password.trim());

      this.authService.loginAdmin(formParams).subscribe((res) => {
        if(res.status == 200 || !res.status)
          this.authService.afterLogin(res);
        else if(res.status == 400 && res.data == true) {
          this.insertCode = true;
          this.toastr.error(res.message);
        }
        else if(res.message) {
          this.password = '';
          this.toastr.error(res.message)
        }
        else {
          this.toastr.error('An error ocurred.')
        }
      }, (error: any) => {
        if (error != null && error.error != null && error.error.message != null)
          this.toastr.error(error.error.message)
        else
          this.toastr.error('An error ocurred.');
      });
  }

  isEmail(search:string):boolean{
    let retVal: boolean = false;
    let regexp  = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    retVal = regexp.test(search);
    return retVal
  }

  sendMail() {
    if (this.isEmail(this.mail.email))
      this.emailValid = true;
    else
      this.emailValid = false;
    if (this.emailValid == false)
      return;
    
    this.authService.sendMail(this.mail).subscribe((response:any) => {
      if (response.status === 200) {
        this.toastr.success(response.message);
      } else
        this.toastr.error(response.message);
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }
  decodeAndExtractBaseUrl(encodedUrl: string): string {
    // Decode the URL
    let decodedUrl = decodeURIComponent(encodedUrl);
  
    // Ensure it is properly formatted (fixing missing "//")
    if (!decodedUrl.startsWith("http")) {
      decodedUrl = decodedUrl.replace(/^https:/, "https://");
    }
  
    try {
      // Create a URL object to extract necessary parts
      const url = new URL(decodedUrl);
      
      // Construct the base URL (protocol + hostname + port)
      return `${url.protocol}//${url.hostname}${url.port ? ':' + url.port : ''}`;
    } catch (error) {
      console.error("Invalid URL:", error);
      return "";
    }
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
  openModal() {
    this.modalComp.open();
  }
}
